let data = {}

const CURRENT_SCRIPT_SRC = document.currentScript.src

const envData = {
  get adminUrl () { return data.adminUrl },
  get analyticsKey () { return data.analyticsKey },
  get androidCallbackUrl () { return data.androidCallbackUrl },
  get apiUrl () { return data.apiUrl },
  get authAudience () { return data.authAudience },
  get authClientId () { return data.authClientId },
  get authCookie () { return data.authCookie },
  get authCustomClaimNamespace () { return data.authCustomClaimNamespace },
  get authHostname () { return data.authHostname },
  get browserExtensionId () { return data.browserExtensionId },
  get browserExtensionUrl () { return data.browserExtensionUrl },
  get chaletUrl () { return data.chaletUrl },
  get corsProxyUrl () { return data.corsProxyUrl },
  get env () { return data.env },
  get feedbackUrl () { return data.feedbackUrl },
  get jaasUrl () { return data.jaasUrl },
  get ldApiKey () { return data.ldApiKey },
  get mobileAndroidUrl () { return data.mobileAndroidUrl },
  get mobileIosUrl () { return data.mobileIosUrl },
  get officePluginUrl () { return data.officePluginUrl },
  get spotPairingUrl () { return data.spotPairingUrl },
  get stripeKey () { return data.stripeKey },
  get vmmsUrl () { return data.vmmsUrl },
  get webUrl () { return data.webUrl }
}

export const getEnvironmentData = async () => {
  const response = await fetch(new URL('/env', CURRENT_SCRIPT_SRC))
  data = await response.json()

  return data
}

export default envData
